export enum EDocumentOriginType {
  snapshot = 'snapshot',
  prompt = 'prompt',
  document = 'document',
}
